export default __webpack_public_path__ + "static/media/Charcoal.894a649d.png";